import { render, staticRenderFns } from "./RefLower.vue?vue&type=template&id=8436b19e&"
import script from "./RefLower.vue?vue&type=script&lang=js&"
export * from "./RefLower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RefLower.vue"
export default component.exports